<template>

  <TableCommon
    title="客户关系"
    :custome-config="() => vxeShowCustom('xTable3')"
  >
    <template #button>
      <table-button name="add" tip="增加" @click="insertData" />
      <table-button name="delete" tip="删除" @click="removeData" />
    </template>
    <vxe-grid
      ref="xTable3"
      class="table-block"
      border
      :highlight-hover-row="true"
      resizable
      :show-overflow="true"
      height="300"
      max-height="500"
      align="center"
      size="mini"
      :checkbox-config="{ highlight: true }"
      :radio-config="{ highlight: true }"
      :empty-render="{name: 'NotData'}"
      :edit-rules="validRules"
      :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
      :edit-config="{ trigger: 'manual', mode: 'row' }"
      :columns="gridOptions.columns"
      :data="gridOptions.data"
    >
      <template #RELTYP="{ row }">
        <el-select
          v-model="row.RELTYP"
          size="mini"
        >
          <el-option
            v-for="selectItem in selectDataOptions['A0066']"
            :key="selectItem.value"
            :label="selectItem.name"
            :value="selectItem.value"
          />
        </el-select>
      </template>
      <template #PARTNER2="{ row }">
        <wly-input
          v-model="row.PARTNER2"
          input-type="customer"
          @enter="handleEnter(...arguments, row)"
          @handleSuffixClick="showClient($event, row)"
        />
      </template>
      <!-- <template #PHONE="{row}">
            <el-input v-model="row.PHONE" size="mini" placeholder="请输入" />
          </template> -->
    </vxe-grid>

    <el-dialog v-dialogDrag :visible.sync="clientDialog" title="客户选择" width="70%">
      <ClientSelect ref="ClientSelect" mode="RELATION" />
      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="clientDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="confirmClient">确定</el-button>
      </div>
    </el-dialog>
  </TableCommon>

</template>

<script>
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'

export default {
  components: { ClientSelect },
  props: {
    relation: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      clientDialog: false,
      selectDataOptions: {},
      validRules: {
        relationshipType: [
          { required: true }
        ]
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          {
            field: 'RELTYP',
            title: '关系类型',
            slots: { default: 'RELTYP' }
          },
          { field: 'PARTNER2', title: '关系客户', slots: { default: 'PARTNER2' }},
          { field: 'NAME_ORG1', title: '客户描述' },
          { field: 'PHONE', title: '电话' }
        ],
        data: []
      },
      currentRow: null
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.PARTNER = this.$route.query.code
      // 客户关系类型
      this.getSelectDictDataOrigin('A0066')
      this.gridOptions.data = this.relation
    },
    async confirmClient() {
      const data = await this.$refs.ClientSelect.submitForm()
      if (!data) return

      this.currentRow.PARTNER2 = data.customerCode
      this.currentRow.NAME_ORG1 = data.name_org1
      this.currentRow.PHONE = data.zzfld000019
      this.clientDialog = false
    },
    showClient(e, row) {
      this.clientDialog = true
      this.currentRow = row
      e.target.blur()
    },
    submitForm() {
      return this.gridOptions.data
    },
    handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return
      this.currentRow = row

      this.currentRow.PARTNER2 = data.customerCode
      this.currentRow.NAME_ORG1 = data.name_org1
      this.currentRow.PHONE = data.zzfld000019
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    insertData() {
      const insertData = {
        PARTNER: this.PARTNER,
        RELTYP: '',
        PARTNER2: '',
        NAME_ORG1: '',
        PHONE: ''
      }
      this.gridOptions.data.unshift(insertData)
    },
    async removeData() {
      const checkedList = this.$refs.xTable3.getCheckboxRecords()

      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/client-manage/components/ClientRelation.vue